import { useFacilityCountsQuery } from './useFacilityCountsQuery';
import { useUserRoleAssignmentsQuery } from './useUserRoleAssignmentsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface UserRoleAssignMutationParams {
  userId: string;
  roleId: string;
  facilityId: string;
}

export const useUserRoleAssignMutation = createMutationHook(
  'settings.teamPermissions.userRoleAssign',
  (params: UserRoleAssignMutationParams) => ({
    coreUserRoleAssign: {
      __args: {
        input: {
          userId: params.userId,
          roleId: params.roleId,
          facilityId: params.facilityId,
        },
      },
      id: true,
      roleId: true,
      facilityId: true,
    },
  }),
  {
    invalidateQueries: [useUserRoleAssignmentsQuery, useFacilityCountsQuery],
  },
);
